module.exports = __webpack_public_path__ + "static/media/S4N3-3.252f87fc.svg";